
class WorkatoAdmin {
  email;
  fullName;

  constructor(options = {}) {
    this.email = options.email;
    this.fullName = options.name;
  }
}

export default WorkatoAdmin;
